import {AddSchema} from "mobx-graphlink";

export class EngineConfigVariant {
	constructor(data: Partial<EngineConfigVariant>) { Object.assign(this, data); }

	name = "NewVariant";
	enabled = true;
	nameForTTS: string;
	/** Names of variants to inherit from (in order; inheritance works recursively). */
	inheritVariants = [] as string[];
	fieldOverrides = [] as VariantFieldOverride[];
}
AddSchema("EngineConfigVariant", {
	properties: {
		name: {type: "string"},
		enabled: {type: "boolean"},
		nameForTTS: {type: "string"},
		inheritVariants: {items: {type: "string"}},
		fieldOverrides: {items: {$ref: "VariantFieldOverride"}},
	},
});

export class VariantFieldOverride {
	constructor(data: Partial<VariantFieldOverride>) { Object.assign(this, data); }
	/** Example: "general.initialDelay" */
	fieldPath: string;
	value: any;
}
AddSchema("VariantFieldOverride", {
	properties: {
		fieldPath: {type: "string"},
		value: {}, // allows any value type
	},
});